<template>
  <div v-loading="loading">

    <div
        v-for="item of  statistic"
        :key="item.id"
        class="devices"
    >
      <div class="devices__title">{{ item.title }}</div>
      <device-item :devices="item.items"/>

    </div>
  </div>
</template>

<script>
import DeviceItem from "@/components/serviceMenu/DeviceItem"

export default {
  name: "ServiceMenu.Statistic",
  data() {
    return {
      statistic: [],
      loading: false
    }
  },
  components: {
    DeviceItem
  },
  mounted() {
    this.loadData();
  },
  computed: {},
  methods: {
    loadData() {
      this.loading = true

      this.$api.statistic.get().then((response) => {
        this.statistic = response.data
      }).catch(() => {
        this.$notify.error({
          title: "Ошибка загрузки",
          message: "Что-то пошло не так.",
        })
      }).finally(() => {
        this.loading = false
      })

    }
  }
};
</script>

<style scoped lang="scss">
.devices {
  &__title {
    margin: 12px 0;
    font-style: normal;
    font-weight: 500;
    font-size: 13px;
    line-height: 16px;

    color: #111;
  }


}

/deep/ .el-loading-mask {
  min-height: 50px;

}
</style>
